/* Cart Boost — temporizador de reserva del carrito.
   Persiste en sessionStorage para que no se reinicie cada vez que
   Dawn vuelve a renderizar el drawer al cambiar cantidades. */
(function () {
  var KEY = 'cboReservationEnd';

  class CartBoostTimer extends HTMLElement {
    connectedCallback() {
      this.minutes = parseInt(this.getAttribute('data-minutes') || '10', 10);
      this.output = this.querySelector('[data-cbo-clock]');
      this.restart(false);
      this.render();
      this.interval = setInterval(this.render.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    read() {
      try {
        return parseInt(sessionStorage.getItem(KEY) || '0', 10);
      } catch (e) {
        return this._end || 0;
      }
    }

    write(value) {
      this._end = value;
      try {
        sessionStorage.setItem(KEY, String(value));
      } catch (e) {
        /* modo privado: se queda en memoria */
      }
    }

    restart(force) {
      var end = this.read();
      if (force || !end || end <= Date.now()) {
        this.write(Date.now() + this.minutes * 60000);
      }
    }

    render() {
      var diff = this.read() - Date.now();
      if (diff <= 0) {
        this.restart(true);
        diff = this.read() - Date.now();
      }
      var m = Math.floor(diff / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (this.output) {
        this.output.textContent =
          (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      }
    }
  }

  if (!customElements.get('cart-boost-timer')) {
    customElements.define('cart-boost-timer', CartBoostTimer);
  }
})();
